import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustStrip from "./components/TrustStrip";
import CategoryGrid from "./components/CategoryGrid";
import ValueProposition from "./components/ValueProposition";
import AboutSection from "./components/AboutSection";
import BlogPreview from "./components/BlogPreview";
import CTASection from "./components/CTASection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://gtbuy.garden";

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "GTBuy Garden",
  "url": siteUrl,
  "description": "GTBuy Spreadsheet is a data-driven product comparison system that helps users compare prices, track deals, and choose the best products across multiple platforms using structured spreadsheets.",
  "inLanguage": "en",
  "publisher": {
    "@type": "Organization",
    "name": "GTBuy Garden",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/54d75be42d5913aa14ca64dd22e5d1e3.jpeg"
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Header />
      <main>
        <HeroSection />
        <TrustStrip />
        <CategoryGrid />
        <ValueProposition />
        <AboutSection />
        <BlogPreview />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}